import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./Bulleten.css";

const asText = (value, fallback = "") => {
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  return fallback;
};

const Bulleten = ({
  data,
  title,
  id = "why-choose-us",
  eyebrow = "The Axiomos advantage",
  introduction = "We combine product thinking, dependable engineering, and business context to deliver solutions that create lasting value.",
}) => {
  const items = Array.isArray(data) ? data.filter(Boolean) : [];
  const projectTitle = asText(title, "Axiomos");

  return (
    <section
      id={id}
      className="bulleten-section"
      aria-labelledby={`${id}-title`}
    >
      <div className="bulleten-section__decoration" aria-hidden="true" />

      <div className="bulleten-section__container">
        <header className="bulleten-section__intro">
          <span className="bulleten-section__index" aria-hidden="true">
            AX / Value
          </span>

          <div className="bulleten-section__intro-content">
            <p className="bulleten-section__eyebrow">
              <span aria-hidden="true" />
              {eyebrow}
            </p>

            <h2 id={`${id}-title`}>
              Why choose <span>{projectTitle}</span> for your project?
            </h2>

            <p className="bulleten-section__description">{introduction}</p>
          </div>

          <div className="bulleten-section__summary">
            <strong>{String(items.length).padStart(2, "0")}</strong>
            <span>
              {items.length === 1 ? "core advantage" : "core advantages"}
            </span>
          </div>
        </header>

        {items.length > 0 ? (
          <div className="bulleten-section__grid">
            {items.map((item, index) => {
              const question = asText(
                item.question ?? item.title ?? item.name,
                "A dependable delivery approach",
              );
              const answer = asText(
                item.answer ?? item.description ?? item.details,
                "A practical benefit designed to support your project objectives.",
              );

              return (
                <article
                  className="bulleten-card"
                  key={item.id ?? `${question}-${index}`}
                >
                  <div className="bulleten-card__top">
                    <span className="bulleten-card__icon" aria-hidden="true">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <small aria-hidden="true">
                      Benefit / {String(index + 1).padStart(2, "0")}
                    </small>
                  </div>

                  <h3>{question}</h3>
                  <p>{answer}</p>

                  <span className="bulleten-card__line" aria-hidden="true" />
                </article>
              );
            })}
          </div>
        ) : (
          <div className="bulleten-section__empty" role="status">
            <p>Project advantages will be available soon.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Bulleten;
